import ElementUI from "element-ui";

// 对象深拷贝
export function objDeepCopy(obj) {
  return JSON.parse(JSON.stringify(obj));
}

// 我需要一个会改变原数组的过滤
function arrayFilert(list, fn) {
  for (let i = 0; i < list.length;) {
    if (!fn(list[i], i)) {
      list.splice(i, 1);
    } else {
      i++;
    }
  }
  return list;
}

/**
 * 用来过滤数组开始的树结构数据，采用的剔除不相干枝干的逻辑，所以会改变原数组，使用时请传入数组的副本
 * @param {Array} treeList 要过滤的树
 * @param {Funtction} fn 过滤规则
 */
function deepFilter(treeList, fn) {
  return arrayFilert(treeList, (item) => {
    if (item.children && item.children.length) {
      deepFilter(item.children, fn);
      if (item.children.length) {
        return true;
      } else {
        return false;
      }
    } else {
      return fn(item);
    }
  });
}

/** deepFilter的包装，使方法不改变传入的数据  */
export function treeFilter(treeList, fn) {
  return deepFilter(objDeepCopy(treeList), fn);
}



/**
 * Parse the time to string
 * @param {(Object|string|number)} time
 * @param {string} cFormat
 * @returns {string | null}
 */
export function parseTime(time, cFormat) {
  if (arguments.length === 0 || !time) {
    return null
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if ((typeof time === 'string')) {
      if ((/^[0-9]+$/.test(time))) {
        // support "1548221490638"
        time = parseInt(time)
      } else {
        // support safari
        // https://stackoverflow.com/questions/4310953/invalid-date-in-safari
        time = time.replace(new RegExp(/-/gm), '/')
      }
    }

    if ((typeof time === 'number') && (time.toString().length === 10)) {
      time = time * 1000
    }
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const time_str = format.replace(/{([ymdhisa])+}/g, (result, key) => {
    const value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') { return ['日', '一', '二', '三', '四', '五', '六'][value] }
    return value.toString().padStart(2, '0')
  })
  return time_str
}


/**
 * @param {string} type
 * @returns {Date}
 */
export function getTime(type) {
  if (type === 'start') {   // 当日时间戳11位
    var today = new Date(new Date().toLocaleDateString()).getTime()
    return Math.round(today / 1000)
  } else {
    return new Date(new Date().toDateString())
  }
}
/**
 * @param {string} type
 * @param {string} nS
 * @returns {Date}
 */
export function timestamp(nS, type) {

  return type == 'unix' ? formatDate(new Date(parseInt(nS) * 1000)) : (new Date(nS)).getTime() / 1000;

  function formatDate(now) {
    var year = now.getFullYear();
    var month = now.getMonth() + 1;
    if (month < 9) {
      month = "0" + month;
    }
    var date = now.getDate();
    if (date < 9) {
      date = "0" + date;
    }
    var hour = now.getHours();
    if (hour < 9) {
      hour = "0" + hour;
    }
    var minute = now.getMinutes();
    if (minute < 9) {
      minute = "0" + minute;
    }
    var second = now.getSeconds();
    if (second < 9) {
      second = "0" + second;
    }
    return year + "-" + month + "-" + date + " " + hour + ":" + minute + ":" + second;
  }
}

// 图片验证
export function imageFormat(file, _this, wh = [],size = 300) {
  const isIMG =
    file.type === 'image/jpg' ||
    file.type === 'image/jpeg' ||
    file.type === 'image/png'
  const isLt = file.size / 1024 <= size
  if (wh.length > 0 && wh.length > 1) {
    var isSize = new Promise(function (resolve, reject) {
      let width = wh[0]; // 限制图片尺寸为654X270
      let height = wh[1];
      let _URL = window.URL || window.webkitURL;
      let img = new Image();
      img.onload = function () {
        let valid = img.width === width && img.height === height;
        valid ? resolve() : reject();
      }
      img.src = _URL.createObjectURL(file);
    }).then(() => {
      return file;
    }, () => {
      ElementUI.Message.error(`上传图片尺寸率建议${wh[0]}*${wh[1]}`)
      return Promise.reject();
    });
  }
  if (!isIMG) {
      ElementUI.Message.error('上传图片只支持jpg、jpeg、png格式!')
  }
  if (!isLt) {
      ElementUI.Message.error(`上传图片大小不能超过${size}KB!`)
  }
  if (wh.length > 0 && wh.length > 1) {
    return isIMG&&isLt&&isSize
  } else {
    return isIMG&&isLt
  }
}


/**
 * @param {Number} len
 * @returns {string}
 */
 export function randomChar(len) {
  　len = len || 32;
　　var $chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';    /****默认去掉了容易混淆的字符oOLl,9gq,Vv,Uu,I1****/
　　var maxPos = $chars.length;
　　var pwd = '';
　　for (var i = 0; i < len; i++) {
　　　　pwd += $chars.charAt(Math.floor(Math.random() * maxPos));
　　}
　　return pwd;
}


